var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SvgIcon as MuiSvgIcon, } from '@mui/material';
import React, { forwardRef } from 'react';
import { ICON_SIZE_MAP } from '../../utils/constants';
import { resolveSxAsArray } from '../../utils/utils';
import { rem } from '../../utils/rem';
var styles = {
    icon: function (iconSize, width, height) {
        if (iconSize) {
            return {
                height: rem(ICON_SIZE_MAP[iconSize]),
                width: rem(ICON_SIZE_MAP[iconSize]),
            };
        }
        else if (width || height) {
            return {
                height: height ? rem(height) : undefined,
                width: width ? rem(width) : undefined,
            };
        }
        return undefined;
    },
};
var getViewBox = function (fnString) {
    var viewBoxIndex = fnString.search('viewBox');
    var firstQuoteIndex = fnString.indexOf('"', viewBoxIndex);
    var secondQuoteIndex = fnString.indexOf('"', firstQuoteIndex + 1);
    return fnString.substring(firstQuoteIndex + 1, secondQuoteIndex);
};
var getWidthAndHeightForMozilla = function (component) {
    var _a, _b, _c, _d, _e;
    if (React.isValidElement(component) &&
        'render' in component &&
        typeof component.render === 'function') {
        var componentString = (_a = component.render.toString()) !== null && _a !== void 0 ? _a : '';
        var width = (_c = (_b = componentString.match(/width: '(\S*)'/)) === null || _b === void 0 ? void 0 : _b[1]) !== null && _c !== void 0 ? _c : 16;
        var height = (_e = (_d = componentString.match(/height: '(\S*)'/)) === null || _d === void 0 ? void 0 : _d[1]) !== null && _e !== void 0 ? _e : 16;
        return [width, height];
    }
    return [16, 16];
};
var getInferredViewBox = function (component) {
    // @ts-ignore
    return (component === null || component === void 0 ? void 0 : component.render) ? getViewBox(component.render.toString()) : '0 0 16 16';
};
var SvgIcon = forwardRef(function (_a, ref) {
    var _b;
    var component = _a.component, viewBox = _a.viewBox, iconSize = _a.iconSize, sx = _a.sx, props = __rest(_a, ["component", "viewBox", "iconSize", "sx"]);
    var width = props.width;
    var height = props.height;
    // Solve edge case when in mozilla and size is not specified - we need to convert attribute to style.
    if (!iconSize && !width && !height) {
        var isMozilla = navigator.userAgent.match(/Firefox\//);
        if (isMozilla) {
            ;
            _b = getWidthAndHeightForMozilla(component), width = _b[0], height = _b[1];
        }
    }
    return (React.createElement(MuiSvgIcon, __assign({ sx: __spreadArray([styles.icon(iconSize, width, height)], resolveSxAsArray(sx), true), ref: ref, viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : getInferredViewBox(component) }, { component: component }, props)));
});
SvgIcon.displayName = 'SvgIcon';
export default SvgIcon;
